import { Grid } from '@enterprise-ui/canvas-ui-react'
const LifecycleEventsCard = () => {
  return (
    <Grid.Item>
      <p className="hc-fs-lg">[Lifecycle Events go here]</p>
    </Grid.Item>
  )
}
export default LifecycleEventsCard
